import { h, render, Component } from 'preact'; // eslint-disable-line no-unused-vars

export default () => {
  Array.from(document.getElementsByTagName('TwitterIcon')).forEach((el) => {
    el.setAttribute('class', 'icon-wrapper');
    render((
      <svg className="icon icon__twitter" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 26">
        <path className="foreground" d="M32,3.1a11.84,11.84,0,0,1-3.8,1A6.46,6.46,0,0,0,31.1.5a12.61,12.61,0,0,1-4.2,1.6A6.49,6.49,0,0,0,22.1,0a6.59,6.59,0,0,0-6.6,6.59s0,0,0,0a7.72,7.72,0,0,0,.2,1.5A18.82,18.82,0,0,1,2.2,1.2a6.29,6.29,0,0,0-.9,3.3A6.77,6.77,0,0,0,4.2,10a6.11,6.11,0,0,1-3-.8v.1a6.54,6.54,0,0,0,5.3,6.4,9.85,9.85,0,0,1-1.7.2,4.87,4.87,0,0,1-1.2-.1,6.68,6.68,0,0,0,6.1,4.6,12.84,12.84,0,0,1-8.1,2.8A8.6,8.6,0,0,1,0,23.1,19.23,19.23,0,0,0,10.1,26C22.2,26,28.8,16,28.8,7.3V6.4A12.6,12.6,0,0,0,32,3.1Z"/>
      </svg>
    ), el);
  });
};
